const config = {
  sortFilterSlideOutId: 'sort-and-filter',
};

export default config;
